import { render, staticRenderFns } from "./question-faq.vue?vue&type=template&id=c6dc6f36&"
import script from "./question-faq.vue?vue&type=script&lang=js&"
export * from "./question-faq.vue?vue&type=script&lang=js&"
import style0 from "./question-faq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports